import { CurrencyPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AvisoFormComponent } from 'app/main/a2w/gestor/vendas/pedido/aviso-form/aviso-form.component';
import { EnumFuncoes, EnumService, EnumtoArray, StatusAtividade } from 'app/shared/enum.service';
import { UsuarioService } from 'app/shared/usuario.service';
import { throwError } from 'rxjs';
import { ParceiroNegocioDTO } from './../shared/parceiro-negocio.model';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})

export class Functions {
    
    dialogRef: any;
    listaFiliaisGestor = [];
    listaUsuariosGestor = [];
    listaClientesDistribuidor = [];
    
    constructor(
        private _usuarioService: UsuarioService,
        private authenticationService: AuthenticationService,
        private currencyPipe: CurrencyPipe, 
        private _enumService: EnumService,
        private _matDialog: MatDialog,
        private _router: Router,
    ) {}

    stringToArray(string, delimitador, int = null){

        if (string){
            const array = string.split(delimitador);

            if (int){
                array.forEach((element, index) => {
                    array[index] = parseInt(element);
                });

                return array;
            }else{
                return array;
            }
       }

        return [];
    }

    stringToArrayNew(value: any, delimitador: string, int: boolean = false): any[] {
        if (!value) return [];

        let array: any[];

        if (Array.isArray(value)) {
            array = [...value];
        } else if (typeof value === 'string') {
            array = value.split(delimitador);
        } else {
            return [];
        }

        if (int) {
            array = array.map(e => parseInt(e, 10));
        }

        return array;
    }

   arrayToString(array, delimitador, chave): string{

    let retorno = '';

    if (array){
        array.forEach((element: any, index: number) => {
            if (element){
                if (chave){
                    retorno = retorno + ((index > 0) ? delimitador : '') + (element[chave]).toString();
                }else{
                    retorno = retorno + ((index > 0) ? delimitador : '') + element.toString();
                }
            }
        });
    }

    return retorno;

   }
   
    validaLoginAtivo(token?: string){
        
        this._usuarioService.validaLogin(token)
                    .then(res => {
                        if (!res){
                            throwError(new Error('Usuário Inativo.'));
                            this.authenticationService.logout();
                            location.reload();
                            return true;
                        }
                    });
        return false;
    }

    convertParamsToObj(fullParams){

        return Object.fromEntries(
            fullParams.split("&").map(pair => {
                const [key, value] = pair.split("=");

                //converte o valor para tipo apropriado
                let parsedValue: any = value;
                if (value === "true") parsedValue = true;
                else if (value === "false") parsedValue = false;
                else if (!isNaN(Number(value))) parsedValue = Number(value);

                return [key, parsedValue];
            })
        );
    }

    orderById(value) {
        return value.sort((a, b) => a.id - b.id);
    }

    orderByOrdem(value) {
        return value.sort((a, b) => a.ordem - b.ordem);
    }

    orderFiliaisByRazaoSocial(filial) {
        // return filial.sort((a, b) => a.razaoSocial.localeCompare(b.razaoSocial));
        return filial;
    }

    orderVendedoresByNomeVendedor(vendedores){
        return vendedores.sort((a, b) => a.nomeVendedor.localeCompare(b.nomeVendedor));
        //return vendedores;
    }

    orderParcNegByNomeFantasiaParcNeg(vendedores){
        return vendedores.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
        //return vendedores;
    }

    orderGrupoUsuario(list){
        return list.sort((a, b) => a.userGroupName.localeCompare(b.userGroupName));
    }

    infoMore(idPn) {
        if (idPn) {
            window.open(`/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads/${idPn}`, '_blank');
        } else {
            window.open(`/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads/new`, '_blank');
        }
    }

    infoMorePedido(idPedido) {
        if (idPedido) {
            window.open(`/a2w/gestor/vendas/pedidos/${idPedido}`, '_blank');
        } else {
            window.open(`/a2w/gestor/vendas/pedidos/new`, '_blank');
        }
    }

    infoMoreOportunidade(idOportunidade) {
        if (idOportunidade) {
            window.open(`/a2w/gestor/pipeline/oportunidade;id=${idOportunidade}`, '_blank');
        } else {
            window.open(`/a2w/gestor/pipeline/oportunidade`, '_blank');
        }
    }

    /**********************************************METODOS DE ORDENAÇÃO, POR PARCEIRO, VENDEDOR, PRODUTO, CULTURA, EMPRESA, EMPRESA POR REGRA DE NEGOCIO, GRUPO EMPRESA, PROPRIEDADE, DATA DE DESPESA DE RELATORIO E CONTATO**************************************************************** */
    orderPartness(parceiros) {
        const mapeado = parceiros.map(function(value, i) {
            return { index: i, value: value.nomeRazaoSocial.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return parceiros[value.index];
        });
    
        return result;
    }

    ordenaModificaObjParceiro(parceiros) {
        if (!Array.isArray(parceiros)) return [];

        const mapeado = parceiros.map((value, i) => {
            return { index: i, value: value.nomeRazaoSocial.toLowerCase() };
        });

        mapeado.sort((a, b) => {
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });

        const result = mapeado.map(value => {
            const parceiro = parceiros[value.index];
            return {
                nomeRazaoSocial: parceiro.nomeRazaoSocial,
                nomeFantasia: parceiro.nomeFantasia,
                codigoIntegracao: parceiro.codigoIntegracao,
                statusMovimento: parceiro.statusMovimento,
                cidadeEntrega: parceiro.cidadeEntrega,
                cnpj: parceiro.cnpj,
                cpf: parceiro.cpf,                
                id: parceiro.id,
                
                enderecos: parceiro.enderecos.map(x => {
                    return {
                        enderecoLogradouro: x.enderecoLogradouro,
                        flagPrincipal: x.flagPrincipal,
                        bairro: x.bairro,
                        numeroEndereco: x.numeroEndereco,
                        nomeFazenda: x.nomeFazenda,
                        id: x.id
                    }
                })
            };
        });

        return result;
    }

    orderPartnessSalesLeadFilter(parceiros: any[], permitirLeads: any) {
        
        if (permitirLeads === true){
            parceiros = parceiros.filter(x => (x.statusMovimento == 1 && x.statusLead == true) || ((x.statusMovimento == 2 || x.statusMovimento == 3) && x.statusLead == true));	
        } else {
            parceiros = parceiros.filter(x => x.statusMovimento == 1);	
        }
        
        const mapeado = parceiros.map(function(value, i) {
            return { index: i, value: value.nomeRazaoSocial.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return parceiros[value.index];
        });
    
        return result;
    }

    orderPartnessSAP(parceiros) {
        const mapeado = parceiros.map(function(value, i) {
            return { index: i, value: value.nomeParceiro.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return parceiros[value.index];
        });
    
        return result;
    }

    orderSalesPerson(salesPerson) {
        const mapeado = salesPerson.map(function(value, i) {
            return { index: i, value: value.nomeVendedor.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return salesPerson[value.index];
        });
    
        return result;
    }


    ordenaModificaObjVendedor(salesPerson) {
    if (!Array.isArray(salesPerson)) return [];

    const mapeado = salesPerson.map((value, i) => {
        return { index: i, value: value.nomeVendedor.toLowerCase() };
    });

    mapeado.sort((a, b) => {
        return +(a.value > b.value) || +(a.value === b.value) - 1;
    });

    const result = mapeado.map(value => {
        const vendedor = salesPerson[value.index];
        return {
            nomeVendedor: vendedor.nomeVendedor,
            codigoIntegracao: vendedor.codigoIntegracao,
            statusMovimento:  vendedor.statusMovimento,
            flagColaborador: vendedor.flagColaborador,
            id: vendedor.id
        };
    });

    return result;
    }


    orderProducts(products) {
        const mapeado = products.map(function(value, i) {
            return { index: i, value: value.descricaoProduto.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return products[value.index];
        });
    
        return result;
    }

    orderProductsERP(products) {
        const mapeado = products.map(function(value, i) {
            return { index: i, value: value.nome.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return products[value.index];
        });
    
        return result;
    }

    orderCultura(cultura) {
        const mapeado = cultura.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return cultura[value.index];
        });
    
        return result;
    }

    ordenarPorDataMaisAntigaParaAtual(objeto: any[], atributoData: string) {
        if (!objeto || !Array.isArray(objeto) || objeto.length === 0) {
          return [];
        }
      
        // Use a função sort para ordenar com base no atributo de data
        objeto.sort((a, b) => {
          const dataA = new Date(a[atributoData]);
          const dataB = new Date(b[atributoData]);
      
          if (dataA < dataB) return -1;
          if (dataA > dataB) return 1;
          return 0;
        });
      
        return objeto;
      }

    orderSegmentacaoCli(cliente){
        const mapeado = cliente.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return cliente[value.index];
        });
    
        return result;
    }

    orderSafra(safra){
        const mapeado = safra.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return safra[value.index];
        });
    
        return result;
    }

    orderProdSubst(cultura) {
        const mapeado = cultura.map(function (value, i) {
            return { index: i, value: value.descricaoProdSimilares.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return cultura[value.index];
        });
    
        return result;
    }

    orderRoles(regras) {
        
        let mapeado = regras.map(function(value, i) {
            return { index: i, value: value.roleNumber.split('-')[1] };
        });

        mapeado = mapeado.sort((a, b) => a.value - b.value);
    
        const result = mapeado.map(function(value) {
            return regras[value.index];
        });

        return result;
    }

    orderVarivaeisMetas(lista) { 

        if (lista != null && lista != undefined && lista.length > 0){
            const mapeado = lista.map(function(value, i) {
                return { index: i, value: value.descricao.toLowerCase() };
            });
            mapeado.sort(function(a, b) {               
                return +(a.value > b.value) || +(a.value === b.value) - 1;
            });
        
            const result = mapeado.map(function(value) {
                return lista[value.index];
            });
        
            return result;
        }
        
    }

    orderEmpresa(empresa) {
        const mapeado = empresa.map(function(value, i) {
            return { index: i, value: value.razaoSocial.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return empresa[value.index];
        });
    
        return result;
    }

    ordenaModificaObjEmpresa(empresa) {
        if (!Array.isArray(empresa)) return [];

        const mapeado = empresa.map((value, i) => {
            return { index: i, value: value.razaoSocial.toLowerCase() };
        });

        mapeado.sort((a, b) => {
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });

        const result = mapeado.map(value => {
            const emp = empresa[value.index];
            return {
                razaoSocial: emp.razaoSocial,
                nomeFantasia: emp.nomeFantasia,
                cidade: emp.cidade,
                cnpj: emp.cnpj,
                ie: emp.ie,
                codigoIntegracao: emp.codigoIntegracao,
                statusMovimento: emp.statusMovimento,
                id: emp.id
            };
        });

        return result;
    }


    orderEmpresaByRegra(empresa) {
        const mapeado = empresa.map(function (value, i) {
            return { index: i, value: value.empresa.razaoSocial.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return empresa[value.index];
        });
    
        return result;
    }

    orderProp(propriedade) {
        const mapeado = propriedade.map(function(value, i) {
            return { index: i, value: value.parceiroNegocio.nomeRazaoSocial.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return propriedade[value.index];
        });
    
        return result;
    }

    orderIdEmpresa(empresa) {
        const mapeado = empresa.map(function(value, i) {
            return { index: i, value: value.nomeFantasia.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return empresa[value.index];
        });
    
        return result;
    }

    orderGrupoEmpresa(grupoEmpresa) {
        const mapeado = grupoEmpresa.map(function(value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function(value) {
            return grupoEmpresa[value.index];
        });
    
        return result;
    }


    orderGrupoProduto(grupoProduto) {
        const mapeado = grupoProduto.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function(a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return grupoProduto[value.index];
        });
    
        return result;
    }

    orderCondPagto(condPagto) {
        const mapeado = condPagto.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return condPagto[value.index];
        });
    
        return result;
    }

    orderTipoNeg(tipoNeg) {
        const mapeado = tipoNeg.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return tipoNeg[value.index];
        });
    
        return result;
    }

    orderTipoAtividade(tpAtividade) {
        const mapeado = tpAtividade.map(function (value, i) {
            return { index: i, value: value.nmTipoAtividade.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return tpAtividade[value.index];
        });
    
        return result;
    }

    orderRegiao(regiao) {
        const mapeado = regiao.map(function (value, i) {
            return { index: i, value: value.descricao.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return regiao[value.index];
        });
    
        return result;
    }


    orderRelatorioDespesaViagemByData(lancamento){
        lancamento.sort((a,b) =>{
            let dataDespesaA = new Date(a.dataDespesa);
            let dataDespesaB = new Date(b.dataDespesa);
            if (dataDespesaA.getTime() === dataDespesaB.getTime()) {
                return new Date(b.dataLancamento).getTime() - new Date(a.dataLancamento).getTime();
            }
            
            return dataDespesaB.getTime() - dataDespesaA.getTime();
        });
    }

    orderByDateDesc(arr) {
        return arr.sort((a, b) => {
          const dataA: any = new Date(a.dataLancamento);
          const dataB: any = new Date(b.dataLancamento);
          
          
        return dataB - dataA; // Ordem decrescente
          
        });
      }

    orderContato(contato) {
        const mapeado = contato.map(function (value, i) {
            return { index: i, value: value.nomeContato.toLowerCase() };
        });
        mapeado.sort(function (a, b) {               
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });
    
        const result = mapeado.map(function (value) {
            return contato[value.index];
        });
    
        return result;
    }

    
    /*************************************FIM DOS METODOS DE ORDENAÇÃO, POR PARCEIRO, VENDEDOR, PRODUTO, CULTURA, EMPRESA, EMPRESA POR REGRA DE NEGOCIO, GRUPO EMPRESA, PROPRIEDADE, DATA DE DESPESA DE RELATORIO E CONTATO**************************************************************** */
    
    /**********************************************************************************UTILITES****************************************************************************************/

    isUndefinedNullEmptyLength(value: any, isArray: boolean){
        if (isArray){
            if (value != undefined && value != null && value != '' && value.length > 0){
                return true;
            }else{
                return false;
            }
        
        }else{
            if (value != undefined && value != null && value != ''){
                return true;
            }else{
                return false;
            }
        }
        
    }

    retornaCodigoMeda(codigo) {
        
        const obj = {
            formato: 'pt-BR',
            mascara: 'BRL'
        }
        switch(codigo){
            case "R$":
                obj.formato = 'pt-BR';
                obj.mascara = 'BRL';
                return obj;
                
            case "€":
                obj.formato = 'en-US';
                obj.mascara = 'EUR';
                return obj;

            case "$":
                obj.formato = 'en-US';
                obj.mascara = 'USD';
                return obj;

            case "US$":
                obj.formato = 'en-US';
                obj.mascara = 'USD';
                return obj;

            case "USD":
                obj.formato = 'en-US';
                obj.mascara = 'USD';
                return obj;
            default:
                return obj;
        }
        
    }


    validarCodigoIdioma(codigo) {
        
        // Verificar se o código tem o comprimento correto
        if (codigo.length >= 2 && codigo.length <= 3) {
            return false;
        }
    
        // Verificar se o código contém apenas letras
        if (!/^[a-zA-Z-]+$/.test(codigo)) {
            return false;
        }
    
        return true;
    }

    validarCodigoMonetario(codigo) {
        
        // Verificar se o código tem o comprimento correto
        if (codigo.length >= 6) {
            return false;
        }
    
        // Verificar se os primeiros três caracteres são letras maiúsculas
        if (!/^[A-Z]{3}$/.test(codigo.substring(0, 3))) {
            return false;
        }
    
        return true;
    }

    /**********************************************************************************UTILITES****************************************************************************************/

    /*******************************************************************************ORDENAÇÃO TABELAS*************************************************************************************************** */
    orderArray(array, sortOrder: 'asc' | 'desc' = 'asc', descricao?) {
        const mapeado = array.map(function (value, i) {
            
           return { index: i, value: value[descricao] ? value[descricao].toLowerCase() : '' };
        }); 
    
        mapeado.sort(function(a, b) {
            // Determina a ordem com base no parâmetro sortOrder
            const orderMultiplier = sortOrder === 'asc' ? 1 : -1;
            return orderMultiplier * (a.value.localeCompare(b.value));
        });
        
        const result = mapeado.map(function(value) {
            return array[value.index];
        });
        
        return result;
    }

    orderObjectArray(array: any[], sortOrder: 'asc' | 'desc' = 'asc', descricao, stringAux) {

        // Mapeia o array para obter o valor de ordenação
        const mapeado = array.map(function (value, i) {
            // Verifica se o valor é definido e se a propriedade existe
            const valorDescricao =  value[descricao][stringAux];
            return { index: i, value: valorDescricao.toLowerCase() };
        });
    
        // Ordena o array com base na ordem e valor
        mapeado.sort(function(a, b) {
            // Determina a ordem com base no parâmetro sortOrder
            const orderMultiplier = sortOrder === 'asc' ? 1 : -1;
            return orderMultiplier * (a.value.localeCompare(b.value));
        });
    
        
        const result = mapeado.map(function(value) {
            return array[value.index];
        });
    
        return result;
    }


    orderArrayNumber(array, sortOrder: 'maior' | 'menor' = 'maior', descricao?, id?) {
        
        const mapeado = array.map(function (value, i) {
            if(value[descricao] == null) { value[descricao] = 0}
            const numericValue = parseFloat(value[descricao]);
            return { index: i, value: numericValue, id: value[id] };
        });

        if(sortOrder === 'maior'){
            mapeado.sort(function(a, b){
                return b.value - a.value;
            });
        } else if(sortOrder === 'menor'){
            mapeado.sort(function(a, b){
                return a.value - b.value;
            });
        }
        const result = mapeado.map(function (item) {
            return array.find(element => element[id]=== item.id);
        });
        return result;
    }


    orderStatus(array, status: string, nomeCampo){
        let result = array;
        if(status == 'ativo'){
            result = result.filter(x =>  x[nomeCampo] == true || x[nomeCampo] == 1 || x[nomeCampo] == 2)
        } else if(status == 'inativo'){
            result = result.filter(x =>  x[nomeCampo] == false || x[nomeCampo] == 0)
        } else if(status == 'todos'){
            result = array
        }
    
        return result;
    }

    orderArrayByDate(array: any[], sortOrder: 'asc' | 'desc' = 'asc', descricao) {
        // Mapeia o array para obter o valor de ordenação (data)
        const mapeado = array.map((value, i) => {
            return { index: i, value: new Date(value[descricao]) };
        });
    
        // Ordena o array com base na ordem e valor das datas
        mapeado.sort((a, b) => {
            // Determina a ordem com base no parâmetro sortOrder
            const orderMultiplier = sortOrder === 'asc' ? 1 : -1;
            return orderMultiplier * (a.value.getTime() - b.value.getTime());
        });
    
        
        return mapeado.map(value => array[value.index]);
    }

    orderNewStatus(array: any[], sortOrder: 'asc' | 'desc' = 'asc', descricao, tipo){ // Funciona somente para os status de pedido!!!!!!!!!!!!!!!!!
        
        // adiciona o status
        if(tipo == 'pedido'){
            array = array.map((item, i) => {
                let status = this._enumService.statusPedido.filter(x => x.value === item[descricao])
                 return {...item, campoStatus: status[0].text}
             });
        } else if(tipo == 'atividade'){
            array = array.map((item, i) => {
                let status = this.returnStatus(item.idStatus);
                return {...item, campoStatus: status}
             });
        } else if(tipo == 'despesas'){
            array = array.map((item, i) => {
                let status = this.returnStatusDespesa(item.status);
                return {...item, campoStatus: status}
             });
        }
        

        let mapeado = array.map(function (value, i) {
            return { index: i, value: value.campoStatus.toLowerCase() };
         }); 
     
         mapeado.sort(function(a, b) {
             // Determina a ordem com base no parâmetro sortOrder
             const orderMultiplier = sortOrder === 'asc' ? 1 : -1;
             return orderMultiplier * (a.value.localeCompare(b.value));
         });
         
         const result = mapeado.map(function(value) {
             return array[value.index];
         });
         
         return result;
    }

        /*******************************************************************************ORDENAÇÃO TABELAS*************************************************************************************************** */
    /* função para colocar ponto no CEP */
    transformCEP(cep){
        const value = cep;
        if (!value) { return ''; }

        let ponto = '';
        ponto = value.replace(/\D/g, '');
        ponto = value.replace(/(\d{2})/, '$1.');

        return ponto;
    }

    /************************************/

    removeAccent(text: any) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }    

    filterVendedoresGestor(name: any) {
        let retorno = [];
        let lista = [];
        let idVendedorVinculado = this.authenticationService.currentUserValue.userDetails.vendedorId;

        if (this.authenticationService.currentUserValue.userDetails.listaUsuariosGestor.length > 0){
            lista = this.authenticationService.currentUserValue.userDetails.listaUsuariosGestor;
        }

        if (this.authenticationService.currentUserValue.userDetails.vendedorUsuarioLogado && !lista.find(v => v.Id === idVendedorVinculado)){
            lista.push(this.authenticationService.currentUserValue.userDetails.vendedorUsuarioLogado);
        }

        if (lista.length > 0) {
            retorno = lista;
        }

        if (this.authenticationService.currentUserValue.userDetails.listaUsuariosGestor.length > 0){
            if (name.nomeVendedor == undefined){
                retorno = lista.filter(vendedor => this.removeAccent(vendedor.nomeVendedor).toLowerCase().includes(this.removeAccent(name.toLowerCase()).toLowerCase())) 
            }
        }

        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });

        return retorno;

    }

    filterEmpresasVendedoresGestor(name: any) {

        let retorno = [];
        console.log(this.authenticationService.currentUserValue.userDetails.listaEmpresasUsuariosGestor);
        if (this.authenticationService.currentUserValue.userDetails.listaEmpresasUsuariosGestor.length > 0){
            if (name.nomeFantasia == undefined){
                retorno = this.authenticationService.currentUserValue.userDetails.listaEmpresasUsuariosGestor.filter(vendedor => 
                    this.removeAccent(vendedor.nomeFantasia).toLowerCase().includes(this.removeAccent(name.toLowerCase()).toLowerCase()));
            }
        }

        console.log(retorno);
        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return retorno;

    }

    filterEmpresasVendedores(name: any){

        let retorno = [];
        if (this.authenticationService.currentUserValue.userDetails.listaFiliaisVendedor.length > 0){
            if (name.nomeFantasia == undefined){
                retorno = this.authenticationService.currentUserValue.userDetails.listaFiliaisVendedor.filter(empresa => 
                    this.removeAccent(empresa.nomeFantasia).toLowerCase().includes(this.removeAccent(name.toLowerCase()).toLowerCase()));
            }
        }

        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return retorno;
    }

    filterFiliaisGestor(name: any) {

        let retorno = [];

        if (this.authenticationService.currentUserValue.userDetails.listaFiliaisGestor.length > 0){
            if (name.nomeFantasia == undefined){
                retorno = this.authenticationService.currentUserValue.userDetails.listaFiliaisGestor.filter(empresa => 
                    this.removeAccent(empresa.nomeFantasia).toLowerCase().includes(this.removeAccent(name.toLowerCase()).toLowerCase()));
            }
        }

        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return retorno;

    }

    filterVendedorLogado(string = null){

        let filteredVendedores: any[] = [];
        if (this.authenticationService.currentUserValue.userDetails.vendedorId > 0){
            filteredVendedores.push(this.authenticationService.currentUserValue.userDetails.vendedorUsuarioLogado);
        }

        filteredVendedores = filteredVendedores.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return filteredVendedores;
    }
    
    filterParceirosNegocioDistribuidorLojista(name: any) {

        let retorno = [];
        if (this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.length > 0){
            if (name.nomeRazaoSocial == undefined){
                retorno = this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.filter(empresa => 
                    this.removeAccent(empresa.nomeRazaoSocial).toLowerCase().includes(this.removeAccent(name.toLowerCase()).toLowerCase()));
            }
        }
        
        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return retorno;

    }

    filterParceirosNegocioDistribuidorLojistaCpfCnpj(value: any) {

        let retorno = [];
        const cpfCnpj = (value || '').toString().replace(/[^a-zA-Z0-9]/g, '');

        if (cpfCnpj.length >= 3 && this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.length > 0) {
            retorno = this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.filter(cliente =>
                (cliente.cnpj || '').replace(/[^a-zA-Z0-9]/g, '').includes(cpfCnpj)
                || (cliente.cpf || '').replace(/[^a-zA-Z0-9]/g, '').includes(cpfCnpj));
        }

        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });

        return retorno;

    }

    filterParceirosNegocioDistribuidorLojistaCodIntg(cod: any) {

        let retorno = [];
        if (this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.length > 0){
            if (cod.codigoIntegracao == undefined){
                retorno = this.authenticationService.currentUserValue.userDetails.listaClientesDistribuidor.filter(cliente => 
                    this.removeAccent(cliente.codigoIntegracao).toLowerCase().includes(this.removeAccent(cod.toLowerCase()).toLowerCase()));
            }
        }
        
        retorno = retorno.map(x => {
            return {
                ...x,
                id: x.Id
            };
        });
        
        return retorno;

    }

    limparFiltroObjetosInuteis(filtro: any): any {
        const filtroLimpo: any = {};

        Object.keys(filtro).forEach((chave) => {
            const valor = filtro[chave];

            const ehObjetoVazio = typeof valor === 'object' &&
                !Array.isArray(valor) &&
                valor !== null &&
                 valor !== "" &&
                !(valor instanceof Date) &&
                Object.keys(valor).length === 0;

            const ehValorUtil =
                !(valor === null ||
                    valor === undefined ||
                    valor === "" ||
                    ehObjetoVazio ||
                    (Array.isArray(valor) && valor.length === 0) ||
                    valor === 0);

            if (ehValorUtil) {
                filtroLimpo[chave] = valor;
            }
        });

        return filtroLimpo;
    }

    dataFormatadaSql(data){
        const tzoffset = (new Date(data)).getTimezoneOffset() * 60000; // offset in milliseconds
        const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        
        // console.log(localISOTime)  // => '2015-01-26T06:40:36.181'
        return localISOTime;
    }
    

    dateFormatParam(date: any){
        const tzoffset = (new Date(date)).getTimezoneOffset() * 60000; // offset in milliseconds
        const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);          

        return localISOTime;
    }

    formatarDataParaString(data) {
        const ano = data.getFullYear();
        const mes = ("0" + (data.getMonth() + 1)).slice(-2);
        const dia = ("0" + data.getDate()).slice(-2);
        const hora = ("0" + data.getHours()).slice(-2);
        const minutos = ("0" + data.getMinutes()).slice(-2);
        const segundos = ("0" + data.getSeconds()).slice(-2);
        const milissegundos = ("00" + data.getMilliseconds()).slice(-3);

        // Formata a data e hora como string
        const dataString = `${ano}-${mes}-${dia}T${hora}:${minutos}:${segundos}.${milissegundos}Z`;
    
        return dataString;
    }

    dataFormatDDMMYYYY(dataISO: string): string {
        
        // Cria um objeto Date a partir da string no formato ISO
        const data = new Date(dataISO);

        // Extrai o dia, mês e ano do objeto Date
        const dia = String(data.getUTCDate()).padStart(2, '0');
        const mes = String(data.getUTCMonth() + 1).padStart(2, '0'); // Os meses são baseados em zero, por isso adicionamos 1
        const ano = data.getUTCFullYear();

        // Formata a data no formato DD/MM/AAAA
        return `${dia}/${mes}/${ano}`;
      }

    dataFormatYYYYMMDD(data: string): string {
        const dataObj = new Date(data);
    const dia = dataObj.getDate().toString().padStart(2, '0');
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
    const ano = dataObj.getFullYear().toString();
        return `${ano}/${mes}/${dia}`;
    }
    
    formatDateToUTC(date: Date, endOfDay = false): string {
        const utcDate = new Date(Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            endOfDay ? 23 : 0, // Horas (23 para final do dia, 0 para início)
            endOfDay ? 59 : 0, // Minutos
            endOfDay ? 59 : 0, // Segundos
            endOfDay ? 999 : 0 // Milissegundos
        ));
        return utcDate.toISOString(); // Retorna no formato "YYYY-MM-DDTHH:mm:ss.sssZ"
    }

    formatDateBrasilia(date: Date): string {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mi = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        
        return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}.${ms}`;
    }

    public formatMoney(value, tipoMoeda?: any) {
        if(tipoMoeda == "R$" || tipoMoeda == "" || tipoMoeda == null){
            if (!isNaN(value) && value != null) {
              const temp = `${value}`.replace(/\,/g, "");
              this.currencyPipe = new CurrencyPipe('pt-BR');
              return this.currencyPipe.transform(temp, 'BRL');//.replace("$", "");
            } else if(value == null){
              return "";
            }
            return value;
          } else if(tipoMoeda == "US$"){
            if (!isNaN(value) && value != null) {
              const temp = `${value}`.replace(/\,/g, "");
              this.currencyPipe = new CurrencyPipe('en-US');
              return this.currencyPipe.transform(temp, 'USD');//.replace("$", "");
            } else if(value == null){
              return "";
            }
            return value;
          }
    }

    public formatMoneyNoSymbol(value){
		const numeroFormatado = parseFloat(value).toFixed(2);

		// Divide o número em parte inteira e decimal
		const partes = numeroFormatado.split('.');
		let parteInteira = partes[0];
		const parteDecimal = partes[1];
	
		// Adiciona separador de milhares (ponto) à parte inteira
		parteInteira = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	
		// Retorna o número formatado como dinheiro
		return parteInteira + ',' + parteDecimal;
	}

    returnNumberFormatPTBR(value, codigo){ 
        
        if (this.isUndefinedNullEmptyLength(value, false) && value > 0){ 
            return value.toLocaleString(codigo, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        } else {
            return value;
        }
        
    }

    returnNumberFormatPTBR4Casas(value, codigo){ 
        
        if (this.isUndefinedNullEmptyLength(value, false) && value > 0){ 
            return value.toLocaleString(codigo, {minimumFractionDigits: 4, maximumFractionDigits: 4});
        } else {
            return value;
        }
        
    }

    arredondarCasasDecimais(numero) {

        //Se for string converte para number
        if (typeof numero === "string") {
            numero = parseFloat(numero);
        }

        //Converte o número para uma string para facilitar a manipulação
        const numeroStr = numero.toString();

        //Encontra a posição do ponto decimal
        const pontoDecimalIndex = numeroStr.indexOf('.');

        //Se não houver ponto decimal, adiciona duas casas decimais (ex: 10 -> 10.00)
        if (pontoDecimalIndex === -1) {
            return numero.toFixed(2);
        }

        //Calcula o número de casas decimais
        const casasDecimais = numeroStr.length - pontoDecimalIndex - 1;

        //Aplica as regras de arredondamento
        if (casasDecimais <= 2) {
            return numero.toFixed(2);
        }
        if (casasDecimais === 3) {
            return numero;
        }
        if (casasDecimais >= 4) {
            return parseFloat(numero.toFixed(4));
        }
        return numero;
    }

    arredondarCasasDecimaisComVirg(numero: number | string): string {

        // converte string → number
        if (typeof numero === 'string') {
            numero = parseFloat(numero);
        }

        const numeroStr = numero.toString();
        const pontoDecimalIndex = numeroStr.indexOf('.');

        let valorFinal: number;

        if (pontoDecimalIndex === -1) {
            valorFinal = Number(numero.toFixed(2));
        } else {
            const casasDecimais = numeroStr.length - pontoDecimalIndex - 1;

            if (casasDecimais <= 2) {
                valorFinal = Number(numero.toFixed(2));
            } else if (casasDecimais === 3) {
                valorFinal = numero;
            } else {
                valorFinal = Number(numero.toFixed(4));
            }
        }

        // ✅ formata usando vírgula
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4
        }).format(valorFinal);
    }


    returnStatus(value: any){

        if(value){
    
            const aux = EnumtoArray (StatusAtividade).find(x=>x.value == value);
            if(aux){
                return aux.text;
            } else {
                return '';
            } 
        } else{
            return '';
        }
        
      }

    returnStatusDespesa(value: any) {
        
        if (value >= 0) {
            
            const aux = this._enumService.statusPedido.find(x => x.value == value)?.text;
            
            if (aux) {
                return aux.text;
            } else {
                return '';
            }
        } else {
            return '';
        }

    }

    private isCnpjValido(cnpj: string): boolean {
        if (/^([A-Z0-9])\1{13}$/.test(cnpj)) return false;
        if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false;

        const calcularDV = (base: string, pesos: number[]): number => {
            let soma = 0;
            for (let i = 0; i < base.length; i++) {
                soma += (base.charCodeAt(i) - 48) * pesos[i];
            }
            const resto = soma % 11;
            return resto < 2 ? 0 : 11 - resto;
        };

        const base = cnpj.substring(0, 12);
        const dv1 = calcularDV(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
        const dv2 = calcularDV(base + dv1.toString(), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

        return `${dv1}${dv2}` === cnpj.substring(12, 14);
    }

    validarCnpj(control: AbstractControl): ValidationErrors | null {
        const valor = control.value;
        if (!valor) return null;

        const semMascara = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if (semMascara.length !== 14) return { cnpjInvalido: true };

        return this.isCnpjValido(semMascara) ? null : { cnpjInvalido: true };
    }

    validarCpfCnpj = (control: AbstractControl): ValidationErrors | null => {
        const valor = control.value;
        if (!valor) return null;

        const semMascara = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        if (semMascara.length === 11 && /^\d{11}$/.test(semMascara)) {
            if (/^(\d)\1{10}$/.test(semMascara)) return { cpfInvalido: true };

            const calcularDigito = (cpf: string, pesoInicial: number) => {
                let soma = 0;
                for (let i = 0; i < pesoInicial - 1; i++) {
                    soma += parseInt(cpf[i]) * (pesoInicial - i);
                }
                const resto = (soma * 10) % 11;
                return resto === 10 ? 0 : resto;
            };

            const d1 = calcularDigito(semMascara, 10);
            const d2 = calcularDigito(semMascara, 11);
            return d1 === parseInt(semMascara[9]) && d2 === parseInt(semMascara[10]) ? null : { cpfInvalido: true };
        }

        if (semMascara.length === 14) {
            return this.isCnpjValido(semMascara) ? null : { cnpjInvalido: true };
        }

        return { formatoInvalido: true };
    }

    validarRazaoSocialObrigatoria = (control: AbstractControl): ValidationErrors | null => {
        const tipoPessoa = control.parent?.get('tipoPessoa')?.value;
        if (tipoPessoa !== 'juridica') return null;

        const valor = control.value;
        if (!valor || valor.trim().length === 0) return { required: true };

        return null;
    }

    validarNomeObrigatorio = (control: AbstractControl): ValidationErrors | null => {
        const tipoPessoa = control.parent?.get('tipoPessoa')?.value;
        if (tipoPessoa === 'juridica') return null;

        const valor = control.value;
        if (!valor || valor.trim().length === 0) return { required: true };

        return null;
    }

    validaEmail(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const emails = (control.value as string)?.trim();

            if (!emails) {
                return null;
            }

            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            // Caso contenha mais de um e-mail, mas separados apenas por espaço, sem ";"
            const espacosSemSeparador = /\S+\s+\S+/;
            if (espacosSemSeparador.test(emails) && !emails.includes(";")) {
                return { missingSeparator: true };
            }

            // Divide, remove espaços extras e ignora entradas vazias
            const listaEmails = emails
                .split(";")
                .map(e => e.trim())
                .filter(e => e.length > 0);

            for (const email of listaEmails) {
                if (!emailRegex.test(email)) {
                    return { invalidEmail: true, invalidValue: email };
                }
            }

            return null;
        };
    }




    emailPedidoValidacao(email: string) {
        if (email.trim() === '') {
            return false;
        }
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (regex.test(email)) {
            return true;
        } else {
            return false;
        }
    }

    getMonthName(month: number): string {
        const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        // Subtrai 1 do mês porque o índice do array começa em 0
        return months[month - 1];
    }

    verifyPermissionModuloAtividades(): boolean {
        //Verifica se o usuário vendedor campo tem acesso ao módulo de Agenda DV-5357 / Se tem, retorna true
        return this.authenticationService.currentUserValue.userDetails.moduloAtividades == true       
    }

    verifyPermissionModuloPedidos(): boolean {
        //Verifica se o usuário vendedor campo tem acesso ao módulo de Pedidos Offline DV-5357 / Se tem, retorna true
        return this.authenticationService.currentUserValue.userDetails.moduloPedidos == true       
    }

    openDialogIfNotPermission(flag: string) {
        let permission: boolean = true;

        if(!this.authenticationService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorCampo).ativo) {
            return;
        }  

        if(flag == 'agenda') {
            permission = this.verifyPermissionModuloAtividades();
        }

        if(flag == 'pedidos') {
            permission = this.verifyPermissionModuloPedidos();
        }

        if(flag== 'agenda/pedidos') {
            permission = (this.verifyPermissionModuloAtividades() || this.verifyPermissionModuloPedidos());
        }

        if(permission) {
            return;
        }

        this.dialogRef = this._matDialog.open(AvisoFormComponent, {
            panelClass: 'aviso-form-dialog',
            data: {
                title: 'Acesso Restrito',
                aviso: 'Você não possui permissão para acessar esta funcionalidade. Caso necessite acesso, entre em contato com o Administrador do sistema.',
                arrayMessage: '',
                permiteEstoque: '',
                msgEstoque: '',
                alignButton: true
            }
        });

        this.dialogRef.afterClosed().subscribe( (resposta) => {
            console.log(resposta)
            this._router.navigate(['/a2w/inicio']);
        })

    }

    //FUNCTION
    decode(element: string) {    
        const result: string = atob(element);
        return result; 
    }

    verificaFinalDeSemanaOrFeriado(date, holidays) {
        // Obter o dia da semana
        const day = date.getDay();
        if (day === 0 || day === 6) {
            return true; // É fim de semana
        }

        // Formatar a data no padrão YYYY-MM-DD em UTC
        const formattedDate = date.toISOString().split('T')[0];

        // Verificar se a data está na lista de feriados
        const isHoliday = holidays.some(holiday => holiday.date === formattedDate);

        return isHoliday; // Retorna true se for feriado, false caso contrário
    }

    public retornaCor(index){
        const presetColors = [
            '#a5d6a7',   
            '#f48fb1', 
            '#d32f2f', 
            '#81d4fa', 
            '#26c6da', 
            '#ccff90', 
            '#ff7043', 
            '#6d4c41', 
            '#424242', 
            '#cfd8dc', 
            '#37474f', 
            '#b0bec5', 
            '#81c784',
            '#f06292',
            '#ffcdd2',
            '#c8e6c9',
            '#aed581',
            '#ba68c8',
            '#f8bbd0',
            '#673ab7',
            '#fbc02d',
            '#ff6f00',
            '#aeea00', 
            '#ffecb3', 
            '#ffb74d', 
            '#6200ea', 
            '#bbdefb', 
            '#4fc3f7', 
            '#00bcd4', 
            '#b2ff59', 
            '#ff5722', 
            '#5d4037', 
            '#e0f2f1',   
            '#e040fb',
            '#009688', 
            '#388e3c', 
            '#c2185b', 
            '#f44336', 
            '#4a148c', 
            '#eeff41', 
            '#e8f5e9', 
            '#c5e1a5', 
            '#ce93d8', 
            '#fce4ec', 
            '#7e57c2', 
            '#fdd835', 
            '#ff8f00', 
            '#ffd180', 
            '#3949ab', 
            '#1565c0', 
            '#80d8ff', 
            '#00e5ff', 
            '#d4e157', 
            '#ff3d00', 
            '#fafafa', 
            '#b0bec5', 
            '#ffd600', 
            '#ffe0b2', 
            '#7c4dff', 
            '#304ffe', 
            '#b3e5fc', 
            '#4dd0e1', 
            '#33691e', 
            '#ff8a65', 
            '#795548', 
            '#616161', 
            '#263238',    
            '#ffebee',   
            '#ab47bc',   
            '#c0ca33',   
            '#f9a825',   
            '#ffe57f',   
            '#5e35b1',   
            '#283593',   
            '#82b1ff',   
            '#00b0ff',   
            '#9ccc65',   
            '#ff9100',   
            '#efebe9',   
            '#eeeeee',   
            '#78909c',  
            '#b2dfdb',
            '#00796b', 
            '#00bfa5', 
            '#dcedc8', 
            '#e1bee7', 
            '#d50000', 
            '#9575cd', 
            '#ffeb3b', 
            '#ffa000', 
            '#e65100', 
            '#3f51b5', 
            '#1976d2', 
            '#01579b', 
            '#18ffff', 
            '#dce775', 
            '#ff6e40', 
            '#5d4037', 
            '#cfd8dc', 
            '#1b5e20', 
            '#00695c',
            '#b9f6ca',
            '#ff80ab',
            '#c62828',
            '#d500f9',
            '#fffde7',
            '#ffe082',
            '#ffa726',
            '#e8eaf6',
            '#90caf9',
            '#29b6f6',
            '#00acc1',
            '#76ff03',
            '#f4511e',
            '#4e342e',
            '#ffffff',
            '#78909c',
            '#880e4f', 
            '#212121', 
            '#26a69a', 
            '#43a047', 
            '#d81b60', 
            '#ef5350', 
            '#6a1b9a', 
            '#f4ff81', 
            '#ffea00', 
            '#fff3e0', 
            '#b388ff', 
            '#3d5afe', 
            '#e1f5fe', 
            '#80deea', 
            '#558b2f', 
            '#ffab91', 
            '#8d6e63', 
            '#757575', 
            '#00897b', 
            '#2e7d32', 
            '#ad1457', 
            '#e53935', 
            '#ea80fc', 
            '#c6ff00', 
            '#fff8e1', 
            '#ffcc80', 
            '#651fff', 
            '#e3f2fd', 
            '#ffab40',
            '#303f9f',
            '#0d47a1',
            '#40c4ff',
            '#00b8d4',
            '#cddc39',
            '#dd2c00',
            '#f5f5f5',
            '#90a4ae',
            '#9c27b0',
            '#afb42b',
            '#f57f17',
            '#ffd740',
            '#512da8',
            '#1a237e',
            '#448aff',
            '#0091ea',
            '#8bc34a',
            '#ff6d00',
            '#d7ccc8',
            '#e0e0e0',
            '#607d8b',
            '#80cbc4', 
            '#66bb6a', 
            '#004d40',
            '#69f0ae',
            '#ff4081',
            '#b71c1c',
            '#aa00ff',
            '#fff9c4',
            '#ffd54f',
            '#ff9800',
            '#c5cae9',
            '#64b5f6',
            '#03a9f4',
            '#0097a7',
            '#64dd17',
            '#e64a19',
            '#3e2723',
            '#eeeeee',
            '#455a64',
            '#ec407a', 
            '#ef9a9a', 
            '#8e24aa', 
            '#9e9d24', 
            '#ffff8d', 
            '#ffc400', 
            '#4527a0', 
            '#8c9eff', 
            '#2979ff', 
            '#e0f7fa', 
            '#7cb342', 
            '#64ffda', 
            '#00c853', 
            '#c51162', 
            '#ff5252', 
            '#d1c4e9', 
            '#fff176', 
            '#ffc107', 
            '#f57c00', 
            '#7986cb', 
            '#2196f3', 
            '#0288d1', 
            '#006064', 
            '#f0f4c3', 
            '#bf360c', 
            '#bcaaa4', 
            '#616161', 
            '#fbe9e7', 
            '#bcaaa4', 
            '#bdbdbd', 
            '#546e7a', 
            '#4db6ac', 
            '#4caf50', 
            '#e91e63', 
            '#e57373', 
            '#7b1fa2', 
            '#827717', 
            '#ffff00', 
            '#ffab00', 
            '#311b92', 
            '#536dfe', 
            '#2962ff', 
            '#b2ebf2', 
            '#689f38', 
            '#ffccbc', 
            '#a1887f', 
            '#9e9e9e', 
            '#a7ffeb', 
            '#00e676', 
            '#f50057', 
            '#ff8a80', 
            '#ede7f6', 
            '#fff59d', 
            '#ffca28', 
            '#fb8c00', 
            '#9fa8da', 
            '#42a5f5', 
            '#039be5', 
            '#00838f', 
            '#f9fbe7', 
            '#d84315', 
            '#d7ccc8', 
            '#bdbdbd', 
            '#455a64',
            '#1de9b6', 
            '#f1f8e9', 
            '#f3e5f5', 
            '#ff1744', 
            '#b39ddb', 
            '#ffee58', 
            '#ffb300', 
            '#ef6c00', 
            '#5c6bc0', 
            '#1e88e5', 
            '#0277bd', 
            '#84ffff', 
            '#e6ee9c', 
            '#ff9e80', 
            '#8d6e63', 
            '#eceff1'  
        ];

        return presetColors[index];
    }
    
    getGeoLocation(address: string){
        new google.maps.geocode({
            'address': address
        }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                results.next(results[0].geometry.location);
                results.complete();
            } else {
                console.log('Error: ', results, ' & Status: ', status);
                results.error();
            }
        });
    }

    validationParceiro(parceiro: ParceiroNegocioDTO, tipo: string): string {        
        if (!parceiro) return '';

        let retornoParceiro = '';
        switch (tipo) {
            case 'CNPJ/CPF':
                retornoParceiro = parceiro.cnpj ? parceiro.cnpj : parceiro.cpf;
                break;
            case 'NOME FANTASIA':
                retornoParceiro = parceiro.nomeFantasia;
                break;
            case 'NOME DO ENDEREÇO PRINCIPAL':
                retornoParceiro = parceiro.enderecos?.find(x => x.flagPrincipal)?.nomeFazenda ?? '';
                break;
            default:
                retornoParceiro = parceiro.nomeFantasia;
                break;

        }

        retornoParceiro += ' - ' + parceiro.cidadeEntrega;

        return retornoParceiro;
    }

}

declare let google: any;
interface Marker {
  lat: number;
  lng: number;
}
